export default __webpack_public_path__ + "static/media/parok-gana.cd2320a1.png";